'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import a$1 from "../defs/Shield.js";
var f = Object.defineProperty, p = Object.defineProperties;
var s = Object.getOwnPropertyDescriptors;
var t = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty, d = Object.prototype.propertyIsEnumerable;
var m = (o, e, r) => e in o ? f(o, e, { enumerable: true, configurable: true, writable: true, value: r }) : o[e] = r, a = (o, e) => {
  for (var r in e || (e = {}))
    c.call(e, r) && m(o, r, e[r]);
  if (t)
    for (var r of t(e))
      d.call(e, r) && m(o, r, e[r]);
  return o;
}, i = (o, e) => p(o, s(e));
const I = forwardRef((o, e) => /* @__PURE__ */ a__default.createElement(b, i(a({ ref: e }, o), { weights: a$1 })));
I.displayName = "Shield";
export {
  I as Shield
};
